import * as React from 'react';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

export const useStateXM = (entityKey?: string) => {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Configuration.StateServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Configuration.StateServiceClient, settings.servicesUrl, 'bff.cygnus.configuration.state'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Configuration.StateContext({ entityKey }));
    React.useEffect(() => {
        setContext(new Services.Configuration.StateContext({ entityKey }));
    }, [ entityKey ])

    const [ state, setState ] = React.useState<Services.ConfigurationProjectionIntegration.Entity>();
    React.useEffect(() => {(async () => {
        if (!serviceClient)
            return;
        if (!context.entityKey)
            return;

        const state = await serviceClient.get(context);
        setState(state);
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient, context ]);

    const refresh = async () => {
        const state = await serviceClient?.get(context);
        setState(state);
    }

    return [ state, refresh ] as const;
}